import * as React from 'react';

const AttendanceIllustrationSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 784 580" {...props}>
        <g
            id="attendance-illustration_svg__attendees_illustration"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <g id="attendance-illustration_svg__NoShows-03">
                <path
                    d="M758.29 335.264c10.704-21.85 20.128-44.192 23.947-68.603 3.871-24.867 1.752-51.33-10.213-73.478-11.964-22.149-32.302-50.68-57.422-51.943-14.907-.754-37.33 8.979-47.962 8.575-15.136-.579-2.26-35.651.14-49.733 1.664-9.856-3.504-21.044-11.106-27.094a61.023 61.023 0 00-7.288-4.735c-7.252-4.226-15.047-8.628-23.543-9.522-3.504-.369-7.007 1.473-8.11-1.93-.771-2.332.648-7.154.875-9.61.981-11.117 2.26-22.288 2.733-33.441a13.423 13.423 0 00-3.731-9.663A12.507 12.507 0 00607.85 0c-8.216-.104-10.913 8.278-11.526 10.856-2.96 12.065-10.213 67.165-11.422 76.494-.192.298-.385.632-.56.965-7.27-7.418-14.014-15.38-20.443-23.359-15.906-19.763-15.31-46.331-44.354-54.626-19.812-5.647-41.499 0-59.227 10.522-17.727 10.522-23.84 22.797-29.06 44.192-17.08-26.13-34.177-36.406-51.747-34.074-17.57 2.333-30.919 12.872-34.282 32.846-33.178-65.078-95.61-34.16-83.698 40.036.963 6.015 6.411 22.43 7.585 31.899-16.204-14.608-25.873-52.61-35.473-68.989-8.11-13.941-18.498-28.058-33.913-32.845-11.842-3.63-24.63-1.018-36.647 2.034-18.236 4.612-36.962 10.644-50.397 23.884-9.565 9.435-15.644 21.868-20.233 34.512-8.496 23.482-15.24 52.96-10.843 77.95 3.994 22.797 2.978 23.218-22.773 26.638-22.054 2.928-46.736 6.629-55.898 31.303-5.658 15.256-2.61 32.652 4.555 47.348 7.164 14.696 18.113 26.971 28.938 39.124 11.334 12.749 37.312 32.425 42.638 48.47 5.097 15.415-1.174 41.738-1.086 58.204.245 41.527 4.344 83.316 20.425 121.984 21.248 50.102 58.981 90.278 57.037 146.974-1.91 55.117 12.122 108.936 15.52 163.685.193 3.297-.175 8.277-.368 13.573-62.677 14.17-101.829 34.32-101.829 56.678 0 42.93 144.309 77.722 322.32 77.722 178.013 0 322.321-34.792 322.321-77.722 0-23.428-43.023-44.437-111.043-58.694 9.057-15.432 16.834-32.969 22.387-43.842 19.27-37.51 33.704-77.16 46.965-117.213 13.138-39.598 12.647-83.79 16.501-125.229 8.338-89.33 30.76-165.807 70.07-246.036z"
                    id="attendance-illustration_svg__Path"
                    fill="#FAEB5A"
                    fillRule="nonzero"
                    opacity={0.05}
                />
                <path
                    d="M521.886 240.332c42.394-44.033 138.81-106.109 163.022-8.283 7.356 29.677.314 60.864-7.844 90.314-6.624 23.991-13.318 47.649-15.079 72.588-1.743 24.009-13.684 43.174-23.446 65.252-25.85 58.495-37.495 121.87-48.268 184.595-5.421 31.59-10.633 63.286-17.432 94.666-3.486 15.971-7.879 31.59-11.697 47.527-3.486 14.25-10.668 27.062-13.683 41.436-2.336 11.127-1.43 23.43 4.95 32.801a61.104 61.104 0 006.711 7.863l12.43 13.058c2.213 2.316 4.531 4.843 5.09 8.002 1.097 6.126-5.23 11.531-11.401 11.83-6.17.298-11.94-2.861-17.31-5.933-14.398-8.248-30.871-15.461-44.137-25.448-9.082-6.827-9.57-13.864-9.692-24.833-.418-36.365.593-72.8.889-109.163l1.743-218.836 1.743-210.095c.297-24.605 6.067-49.334 23.411-67.34z"
                    id="attendance-illustration_svg__Path"
                    fill="#4B4D63"
                    fillRule="nonzero"
                    opacity={0.08}
                />
                <path
                    d="M232.903 159.606c-34.48-20.679-72.025 3.21-71.342 42.71.21 12.277 5.516 24.695 15.165 32.307 2.767 2.192 6.199 4.63 6.059 8.156a10.041 10.041 0 01-2.014 4.753 347.674 347.674 0 00-35.741 73.263 267.42 267.42 0 00-14.78 78.63c-2.609 56.425 15.603 111.57 35.286 164.504 11.505 30.922 23.763 61.914 42.203 89.259 6.181 9.155 13.729 17.54 19.543 26.94 5.813 9.402 5.989 19.119 7.757 29.818 2.26 13.628 7.46 27.063 11.61 40.34 9.562 30.572 19.053 64.09 7.268 93.873-2.434 6.156-5.814 12.277-5.621 18.89.823 27.712 63.304 2.824 77.506-.404 16.723-3.806 31.013-7.472 35.776-23.8 5.708-19.61-.316-49.971-1.436-70.3-2.61-47.795-7.968-95.397-9.737-143.245-3.327-89.154 5.639-179.167-8.563-267.251-4.115-25.503-10.244-50.952-21.802-74.07-12.538-25.046-35.023-43.849-47.106-68.404-10.612-21.837-17.704-42.586-40.031-55.969z"
                    id="attendance-illustration_svg__Path"
                    fill="#6F7287"
                    fillRule="nonzero"
                    opacity={0.1}
                />
                <path
                    d="M398.877 115.306c-27.993-28.617-70.252-14.99-79.444 23.318-2.878 11.93-.872 25.223 6.523 34.984 2.128 2.799 4.831 6.017 3.802 9.376a9.897 9.897 0 01-3.122 4.093 345.968 345.968 0 00-52.759 61.748 266.88 266.88 0 00-33.905 72.12c-16.604 53.824-12.836 111.618-7.08 167.663 3.365 32.728 7.412 65.719 18.365 96.75 3.662 10.39 8.842 20.414 12.104 30.926 3.261 10.513.994 19.959 0 30.647-1.239 13.731.418 27.987 1.098 41.859 1.587 31.906 2.372 66.645-16.446 92.429-3.89 5.335-8.72 10.39-10.134 16.827-6.139 26.956 60.311 18.63 74.805 19.084 17.092.525 31.777.56 40.428-13.993 10.464-17.493 12.208-48.314 16.202-68.22 9.436-46.792 16.168-94.091 26.406-140.708 19.185-86.901 50.23-171.529 58.567-260.127 2.406-25.661 2.86-51.76-2.512-76.966-5.825-27.34-22.848-51.112-28.307-77.875-4.778-23.597-6.418-45.41-24.591-63.935z"
                    id="attendance-illustration_svg__Path"
                    fill="#6F7287"
                    fillRule="nonzero"
                    opacity={0.08}
                />
                <path
                    d="M567.178 255.043c-1.355 3.17-7.582 6.341-10.31 8.402a141.526 141.526 0 01-17.117 11.73c-1.583.882-15.218 7.698-14.866.688.95-19.094 2.393-35.898 2.727-49.848.194-4.086.3-8.331.264-12.682-.106-9.283-1.671-17.438-9.007-23.127-7.67-5.954-16.731-6.147-20.953-16.857-.968-2.413-.458-32.321 3.694-31.353 1.605.32 3.226.556 4.856.705 1.038-11.009 2.832-20.855 3.8-28.183a16.435 16.435 0 00-.282-2.818c11.506-14.655-33.426-51.609-62.56-17.984-17.275 19.975 4.188 42.943 4.346 43.102l-12.315 29.82c-2.71.6-55.17 13.933-72.5 29.82-11.804 10.833-46.62 30.455-57.176 67.093-13.054 45.338 49.84 122.84 54.678 124.32 6.72 2.078 101.282-21.384 131.084-31.706a59.275 59.275 0 0013.74-10.251c20.9 0 36.504-21.26 47.113-36.813a270.096 270.096 0 0016.555-28.042c5.277-10.022 15.059-16.575 19.72-26.773 3.326-7.293-.175-15.853-4.01-22.81a5.283 5.283 0 00-1.97-2.326 5.079 5.079 0 00-2.464-.37c-3.888 0-7.987.106-11.294 2.132a14.588 14.588 0 00-6.21 10.797c-.51 3.84 1.952 9.864.457 13.334z"
                    id="attendance-illustration_svg__Path"
                    fill="#6F7287"
                    fillRule="nonzero"
                    opacity={0.08}
                />
                <path
                    d="M232 350l364 11.153s-67.167 508.221-72.37 504.83c-5.2-3.391-238.194-14.544-238.194-14.544L232 350z"
                    id="attendance-illustration_svg__Path"
                    fill="#6F7287"
                    fillRule="nonzero"
                    opacity={0.1}
                />
                <path
                    d="M228 418.29s72.126-7.783 73.885-2.383c1.759 5.4 21.796 65.004 20.001 109.042-1.794 44.038-13.528 164.44-11.716 179.71 1.812 15.269 16.273 50.208 6.351 155.341l-24.118-1.175s-19.914-115.528-23.186-151.467c-3.272-35.938-17.275-169.892-17.275-169.892l-21.919-10.396L228 418.29z"
                    id="attendance-illustration_svg__Path"
                    fill="#324B8C"
                    fillRule="nonzero"
                />
                <path
                    d="M197.286 424.182S182 486.476 182 526.845c0 40.368 31.804 188.981 32.714 194.318.911 5.337 16.59 136.837 16.59 136.837H262s-8.34-125.393-9.25-154.09c-.91-28.697-7-179.113-7-179.113L237.357 420l-40.071 4.182z"
                    id="attendance-illustration_svg__Path"
                    fill="#324B8C"
                    fillRule="nonzero"
                />
                <path
                    d="M325.746 334.023c26.684 16.622 53.438 35.404 53.088 46.433-.524 16.516-46.478 59.816-59.278 65.499-1.626 18.64-7.903 24.642 4.949 16.48 18.955-12.055 83.531-45.654 92.851-79.66 8.743-31.864-74.176-113.048-90.928-119.58-4.668-1.77-13.744-2.797-18.92-3.169-23.064-1.664-8.603 75.625 18.168 73.961"
                    id="attendance-illustration_svg__Path"
                    fill="#F9A31F"
                    fillRule="nonzero"
                />
                <path
                    d="M325.788 333.706c26.658 16.56 52.495 35.182 52.163 46.081-.367 11.921-29.803 40.314-38.258 47.439 3.739 8.412 13.976 18.605 25.139 20.774 20.23-16.136 45.7-43.453 52.408-65.691 9.573-31.514-74.105-112.619-90.84-119.126-4.665-1.763-13.732-2.786-18.903-3.157-23.042-1.657-8.595 75.338 18.15 73.68"
                    id="attendance-illustration_svg__Path"
                    fill="#39364F"
                    fillRule="nonzero"
                />
                <path
                    d="M191.794 273.796c-15.226 10.639-44.411 158.184-25.77 161.996 28.736 5.87 45.938-114.688 45.938-114.688s7.544-57.15-6.399-52.876c-4.526 1.401-9.277 2.43-13.769 5.568"
                    id="attendance-illustration_svg__Path"
                    fill="#F9A31F"
                    fillRule="nonzero"
                />
                <path
                    d="M202.017 276.268c30.405 23.662 66.41 24.203 101.983 11.325-3.232-21.236-2.437-88.82-13.673-112.936-5.998-12.895-16.369-21.097-25.806-18.619-14.572-6.875-28.556 5.026-33.136 15.181-6.015 13.315-15.28 83.586-29.385 105.05"
                    id="attendance-illustration_svg__Path"
                    fill="#1E0A3C"
                    fillRule="nonzero"
                />
                <path
                    d="M232.409 221.809c1.722 2.682 6.89 5.894 11.316 7.906l-5.426 34.662s-1.136 11.083 15.192 11.613c8.92.273 17.153-4.887 20.979-13.149l-5.65-34.132c9.13-3.918 11.61-5.912 12.815-10.589 5.684-22.678 2.67-59.123-26.37-58.099-35.774 1.27-27.834 50.157-22.856 61.876M229.782 196.2c-5.335-7.102-14.566 4.834.218 9.8M286.208 196.529c4.23-7.837 15.3 4.6-.208 9.471"
                    id="attendance-illustration_svg__Path"
                    fill="#F9A31F"
                    fillRule="nonzero"
                />
                <path
                    d="M228.076 193.124s-2.907-36.03 27.242-37.102c30.15-1.073 28.67 37.978 28.67 37.978s-4.007-8.668-5.727-12.904c-19.09.68-46.436-1.787-46.436-1.787l-3.75 13.815z"
                    id="attendance-illustration_svg__Path"
                    fill="#1E0A3C"
                    fillRule="nonzero"
                />
                <path
                    d="M248.069 213.27a3.992 3.992 0 001.904 4.179 4.005 4.005 0 004.583-.37 3.99 3.99 0 001.205-4.432 4 4 0 00-3.766-2.635 3.644 3.644 0 00-3.926 3.257"
                    id="attendance-illustration_svg__Path"
                    fill="#F16B31"
                    fillRule="nonzero"
                />
                <path
                    d="M256.036 186.174a55.204 55.204 0 01-.982 6.167 36.992 36.992 0 01-4.036 11.255l-.429-.244.357-.349a8.522 8.522 0 004.25 1.743c.656.127 1.317.22 1.983.278H258V206a20.222 20.222 0 01-2.964-.348 9.473 9.473 0 01-4.768-2.039l-.268-.261.196-.331a36.94 36.94 0 003.929-10.958c.357-1.742.59-3.24.75-4.32 0-.558.125-.976.16-1.29.036-.314 0-.453 0-.453l1 .174z"
                    id="attendance-illustration_svg__Path"
                    fill="#D95A2A"
                    fillRule="nonzero"
                />
                <path
                    id="attendance-illustration_svg__Path"
                    fill="#1B1030"
                    fillRule="nonzero"
                    d="M280 225.158L262.34 232l-.34-1.158L279.678 224"
                />
                <path
                    id="attendance-illustration_svg__Path"
                    fill="#F9A31F"
                    fillRule="nonzero"
                    d="M264 184l-.272-14L262 183.53z"
                />
                <path
                    d="M281 203.84a.84.84 0 110-1.68.84.84 0 010 1.68M277 201.84a.84.84 0 110-1.68.84.84 0 010 1.68M283 199.84a.84.84 0 110-1.68.84.84 0 010 1.68M275 207.84a.84.84 0 110-1.68.84.84 0 010 1.68M263 201.84a.84.84 0 110-1.68.84.84 0 010 1.68M269 201.84a.84.84 0 110-1.68.84.84 0 010 1.68M255 199.84a.84.84 0 110-1.68.84.84 0 010 1.68M249 199.84a.84.84 0 110-1.68.84.84 0 010 1.68M259 199.84a.84.84 0 110-1.68.84.84 0 010 1.68M235 203.84a.84.84 0 110-1.68.84.84 0 010 1.68M247 201.84a.84.84 0 110-1.68.84.84 0 010 1.68M241 199.84a.84.84 0 110-1.68.84.84 0 010 1.68M233 199.84a.84.84 0 110-1.68.84.84 0 010 1.68"
                    id="attendance-illustration_svg__Path"
                    fill="#F58423"
                    fillRule="nonzero"
                />
                <path
                    d="M262 212.454c-2.759 1.09-6.027 1.628-9.331 1.536a43.782 43.782 0 01-8.669-.931l.35-.617c2.673.568 5.483.87 8.319.896a28.279 28.279 0 006.506-.71c.564-.136 1.11-.295 1.637-.477l.39-.151.798.454z"
                    id="attendance-illustration_svg__Path"
                    fill="#D95A2A"
                    fillRule="nonzero"
                />
                <path
                    d="M273.717 195.476a8.896 8.896 0 00-3.44-.744 6.12 6.12 0 00-3.853 1.268l-.424-.62a6.8 6.8 0 014.25-1.378 9.07 9.07 0 013.75.827l-.283.647zM236 192.692a8.446 8.446 0 013.402-.692c1.665.004 3.282.504 4.598 1.423l-.484.577c-1.174-.828-2.622-1.28-4.114-1.282a8.124 8.124 0 00-2.192.308l-.626.205h-.171l-.413-.539z"
                    id="attendance-illustration_svg__Path"
                    fill="#882B1C"
                    fillRule="nonzero"
                />
                <path
                    d="M166.023 435.911c30.583-1.77-16.303-76.916-44.572-127.911A52.623 52.623 0 00110 310.353s24.806 127.398 56.04 125.629"
                    id="attendance-illustration_svg__Path"
                    fill="#F9A31F"
                    fillRule="nonzero"
                />
                <path
                    d="M191.794 273.796c-15.226 10.639-44.411 158.184-25.77 161.996 28.736 5.87 45.938-114.688 45.938-114.688s7.544-57.15-6.399-52.876c-4.526 1.401-9.277 2.43-13.769 5.568"
                    id="attendance-illustration_svg__Path"
                    fill="#39364F"
                    fillRule="nonzero"
                />
                <path
                    d="M166.365 435.786c30.68-4.382 3.936-43.334-24.68-93.786-5.931.438-25.685 20.247-25.685 20.247s24.523 77.29 50.295 73.627"
                    id="attendance-illustration_svg__Path"
                    fill="#39364F"
                    fillRule="nonzero"
                />
                <path
                    d="M319.46 444l-23.418 14.483S294.52 479.15 309.738 484C315.452 472.599 322 459.954 322 459.954"
                    id="attendance-illustration_svg__Path"
                    fill="#F9A31F"
                    fillRule="nonzero"
                />
                <path
                    d="M315.464 438.11c.995-18.859 6.965-63.932 10.536-103.797-18.051 1.038-24.341-46.305-18.46-73.503-6.094-.845-12.668-1.091-30.95-.44a.32.32 0 00-.285.176c-7.533 12.913-33.367 14.989-37.15 1.636a.337.337 0 00-.339-.264c-7.48.106-26.153 3.237-33.33 6.44 2.273 22.395-11.407 52.18-9.24 77.408 3.145 52.286-3.553 81.226-4.246 92.415 0 0 54.83 17.593 123.464 0"
                    id="attendance-illustration_svg__Path"
                    fill="#F05537"
                    fillRule="nonzero"
                />
                <path
                    d="M280 260.788c-2.27 5.436-6.057 9.954-10.824 12.909-4.471 2.805-9.54 4.287-14.7 4.296-4.533.113-9-1.19-12.875-3.752-3.836-2.627-6.566-6.793-7.601-11.595l1.879-.488c.905 4.28 3.335 7.991 6.756 10.32 3.561 2.364 7.669 3.575 11.84 3.489 4.839-.01 9.591-1.393 13.788-4.015 4.415-2.731 7.92-6.916 10.014-11.952l1.723.788zM325.907 340c-6.5-.552-13.075-4.111-17.875-12.156-4.8-8.044-8.032-20.556-8.032-39.154a222.86 222.86 0 012.055-28.69l1.046.125a221.283 221.283 0 00-2.055 28.565c0 18.438 3.194 30.79 7.9 38.603 4.708 7.813 10.89 11.14 17.054 11.657l-.093 1.05zM212 268v3.374c0 33.792-11.19 50.555-11.224 50.626l-.776-.59c.608-.945 11.021-17.493 11.021-49.983v-3.338L212 268zM295.093 446v7.9c0 6.773.377 15.141 2.806 21.741a18.986 18.986 0 005.397 8.16c2.648 2.184 6.05 3.334 9.535 3.222H314v.97h-1.223c-3.73.109-7.367-1.127-10.2-3.464-3.85-3.24-5.937-8.368-7.196-13.86a84.425 84.425 0 01-1.368-16.7v-7.9l1.08-.069z"
                    id="attendance-illustration_svg__Path"
                    fill="#FFF"
                    fillRule="nonzero"
                />
                <path
                    id="attendance-illustration_svg__Path"
                    fill="#F9A31F"
                    fillRule="nonzero"
                    d="M274 183.72l-2-7.72.068 8zM122 311.905l-6.81-28.196-3.982-17.916a5.03 5.03 0 00-1.267-2.385c-1.121-1.158-2.722-1.646-4.26-1.298-1.538.348-2.806 1.485-3.373 3.026l-6.005 16.776a5.144 5.144 0 00.313 4.181L109.776 316"
                />
                <path
                    d="M633.615 256c12.089 34.94 38.214 110.391 36.284 136.438C667.969 418.485 624.562 510 624.562 510L616 445.815 633.615 256z"
                    id="attendance-illustration_svg__Path"
                    fill="#A43B23"
                    fillRule="nonzero"
                />
                <path
                    d="M636.48 260c10.724 24.348 26.267 66.852 31.52 100.174C660.454 372.678 630 380 630 380l6.48-120z"
                    id="attendance-illustration_svg__Path"
                    fill="#324B8C"
                    fillRule="nonzero"
                />
                <path
                    d="M574.189 232.613s59.613 8.113 64.364 30.629c6.399 30.453-10.494 194.495-10.494 194.495L565.095 500l-82.126-39.46s-37.313-180.267-27.245-199.155C465.793 242.495 533.028 232 533.028 232l41.16.613z"
                    id="attendance-illustration_svg__Path"
                    fill="#324B8C"
                    fillRule="nonzero"
                />
                <path
                    d="M574 402l9.476-12.388c.915-1.185 2.561-1.798 4.199-1.562l8.325 1.218L574 402z"
                    id="attendance-illustration_svg__Path"
                    fill="#A43B23"
                    fillRule="nonzero"
                />
                <path
                    d="M461.068 254s-81.053 140.574-59.387 183.059C426.16 485.035 580 415.869 580 415.869l-6.419-15.203s-126.125 28.059-125.966 9.765c.193-21.543 37.492-64.169 37.492-64.169L461.067 254z"
                    id="attendance-illustration_svg__Path"
                    fill="#A43B23"
                    fillRule="nonzero"
                />
                <path
                    d="M458.301 256S424.468 302.905 402 348.347c8.55 20.316 37.616 38.942 57.11 37.583 11.155-16.5 28.89-41.208 28.89-41.208L458.301 256z"
                    id="attendance-illustration_svg__Path"
                    fill="#324B8C"
                    fillRule="nonzero"
                />
                <path
                    d="M592.134 171.216c.516-1.201 6.802-1.767 7.539-.494.737 1.272.424 13.007-3.004 13.272-3.798.318-5.125-11.434-4.535-12.778z"
                    id="attendance-illustration_svg__Path"
                    stroke="#FFF"
                    strokeWidth={2.74}
                />
                <path
                    d="M602 189.786s-4.804.758-6.416.882c-1.977 9.717 2.774 15.008.156 19.558-1.04 1.764-11.897 2.064-11.897 2.064l-8.67 15.995s.849 15.08-9.001 17.16c-12.902 2.734-32.377-5.061-34.372-14.108l13.37-28.36s-29.081-23.35-15.607-42.89c26.395-38.183 60.523-12.857 65.414 1.94 2.393 7.424 7.023 27.759 7.023 27.759z"
                    id="attendance-illustration_svg__Path"
                    fill="#BE4D28"
                    fillRule="nonzero"
                />
                <path
                    d="M594 196a11.323 11.323 0 01-6-2"
                    id="attendance-illustration_svg__Path"
                    stroke="#200B3C"
                    strokeWidth={1.36}
                />
                <path
                    d="M564.904 181.812s7.324-10.327 3.555-14.476c-3.768-4.148-5.777-7.023-5.03-10.654.746-3.632 23.766 7.608 30.663 4.234 4.799-2.341 6.417-16.3-2.418-18.4-14.22-3.443-48.634-5.922-57.682 10.654-3.434 2.85-6.054 6.507-7.608 10.62C515.63 188.594 544.746 204 544.746 204l14.025-15.492s-8.603-2.237-7.412-9.863c1.12-7.16 11.447-.55 13.563 3.081"
                    id="attendance-illustration_svg__Path"
                    stroke="#1E0A3C"
                    strokeWidth={2.58}
                    fill="#200B3C"
                    fillRule="nonzero"
                />
                <path
                    id="attendance-illustration_svg__Path"
                    fill="#A33C23"
                    fillRule="nonzero"
                    d="M584 212.589L564 210l15.823 8z"
                />
                <path
                    d="M591.365 170.587c-.697-1.083-6.796-.568-7.296.729-.501 1.296 1.788 12.963 5.132 12.679 3.666-.302 2.951-12.164 2.164-13.408zM584 178.1l-14 1.8"
                    id="attendance-illustration_svg__Path"
                    stroke="#FFF"
                    strokeWidth={2.74}
                />
                <path
                    d="M561.706 250c-13.2 0-30.11-9.62-31.671-18.837-.21-1.188.553-2.328 1.716-2.566 1.185-.227-.206-1.222 0 0 1.236 7.28 20.926 18.592 32.873 16.707 7.588-1.187 9.047-16.043 9.047-16.183 1.21-.06 2.244.882 2.317 2.112 0 .681.79 16.672-10.677 18.488-1.193.187-2.398.28-3.605.279z"
                    id="attendance-illustration_svg__Path"
                    fill="#1E0A3C"
                    fillRule="nonzero"
                />
                <path
                    d="M627.497 456s-59.221 21.02-143.452 2.873c-3.137 56.051 2.857 186.51-3.505 224.889-9.377 56.279-31.267 116.727-25.624 197.739 26.57 4.939 32.95 1.033 32.95 1.033 8.202-61.149 40.187-124.592 52.578-185.373 4.434-21.772 13.618-88.438 21.032-137.641a2.226 2.226 0 014.416.193c2.138 33.455 2.682 89.157 1.753 115.921-2.12 57.015-16.124 119.74-.21 199.386 26.99 1.506 32.808-3.188 32.808-3.188.351-61.692 23.994-128.673 28.516-190.54 3.4-48.31-1.262-225.292-1.262-225.292zM489.07 455h-.14.14z"
                    id="attendance-illustration_svg__Path"
                    fill="#39364F"
                    fillRule="nonzero"
                />
                <path
                    d="M568.432 420l33.827-12.302 21.582-7.339a5.932 5.932 0 002.786-1.982 6.455 6.455 0 001.093-5.865c-.614-2.021-2.17-3.583-4.137-4.152l-21.29-6.124a5.803 5.803 0 00-5.073.893L562 404.019"
                    id="attendance-illustration_svg__Path"
                    fill="#A43B23"
                    fillRule="nonzero"
                />
                <path
                    d="M359.426 403.223s-45.616 185.625-47.834 191.523c-2.218 5.898-7.3 14.676-6.619 32.302.682 17.625-2.986 88.737-3.737 91.686-.75 2.95-2.288 78.372-2.288 78.372l-2.881 14.118-8.103-3.072s-4.419 30.208 0 30.94c4.418.733 67.026.908 67.026.908l7.771-19.248-3.65-5.236s13.482-159.308 20.119-171.018c6.636-11.71 18.546-68.197 18.546-68.197l18.616-43.156h5.903s15.56 216.268 15.56 236.144c0 19.877-1.152 43.086-1.152 43.086l-3.668 8.726 5.24 14.38 63.725.593v-21.238l-4.191-1.326 2.095-279.877v-98.65L468.382 376l-108.956 27.223z"
                    id="attendance-illustration_svg__Path"
                    fill="#1E0A3C"
                    fillRule="nonzero"
                />
                <path
                    d="M322.309 224.004c-10.873 0-69.089 144.716-63.994 155.283 5.095 10.566 87.122 97.965 87.122 97.965l6.548-26.073a50.29 50.29 0 004.377-5.275c.876-1.494 1.944-.95 5.078 0 1.26.404 2.766 5.503 8.754 5.275 5.988-.229 5.253-3.64 5.253-3.64s-9.472-6.646-9.7-7.507c-.228-.862-.63-3.376-5.918-4.87-5.287-1.495-18.051 7.032-18.051 7.032s-40.27-69.659-44.63-72.859c-4.359-3.2 40.498-72.243 40.498-72.243l16.458 95.89 6.163 9.987 109.27-27.427 8.229-56.772s4.885 57.352 7.003 66.934c2.119 9.582 27.068 98.792 23.777 116.04-3.292 17.248-13.587 39.155-12.361 41.546 1.225 2.39 5.007 12.412 5.007 12.412L498.443 596s16.406-17.705 18.63-35.55a217.312 217.312 0 015.462-28.747S527.648 425 518.771 381.66c-9.28-45.185-7.634-110.765-18.454-134.448-2.591-5.345-64.781-23.524-178.008-23.208z"
                    id="attendance-illustration_svg__Path"
                    fill="#C04E28"
                    fillRule="nonzero"
                />
                <path
                    d="M264 332.069l47.585 18.143 21.484-37.974L349.413 410l120.227-31.555 4.67-31.92 3.171 27.328L522 361.676s-12.092-36.687-12.092-50.673c0-13.986.383-52.899-11.082-64.64-9.932-10.16-29.726-6.959-60.723-13.656 0 0 3.728 25.606-27.757 24.127-43.143-2.018-29.412-32.007-29.412-32.007-29.238-4.767-53.283-3.044-60.636 1.74C304.982 236.411 264 332.068 264 332.068zM356.91 500a111.992 111.992 0 01-14.91-1.004l.19-1.41c.33 0 33.096 4.669 41.73-7.045 8.633-11.714 2.496-63.836 2.427-64.365l1.404-.176c.26 2.167 6.362 53.144-2.705 65.404-5.166 7.028-17.821 8.596-28.137 8.596zM467.314 489.984a8.42 8.42 0 01-5.016-1.285c-8.07-6.109-13.207-21.92-15.356-46.964a306.328 306.328 0 01-.717-35.735h1.382c0 .677-3.088 67.444 15.459 81.484 5.118 3.836 23.597-3.957 30.32-7.272l.614 1.267c-.768.486-17.13 8.505-26.686 8.505z"
                    id="attendance-illustration_svg__Path"
                    fill="#FFF"
                    fillRule="nonzero"
                />
                <path
                    id="attendance-illustration_svg__Rectangle"
                    fill="#DBDAE3"
                    fillRule="nonzero"
                    transform="rotate(-15.08 412.336 393.4)"
                    d="M348.247 385.324l128.187-.063-.008 16.217-128.187.062z"
                />
                <path
                    id="attendance-illustration_svg__Rectangle"
                    fill="#DBDAE3"
                    fillRule="nonzero"
                    transform="rotate(-69.08 288.563 340.76)"
                    d="M280.472 315.182l16.215-.01-.033 51.164-16.215.011z"
                />
                <path
                    id="attendance-illustration_svg__Rectangle"
                    fill="#DBDAE3"
                    fillRule="nonzero"
                    transform="rotate(-15.33 501.37 367.561)"
                    d="M478.192 359.464l46.364-.023-.008 16.217-46.364.023z"
                />
                <path
                    id="attendance-illustration_svg__Path"
                    fill="#BE4D28"
                    fillRule="nonzero"
                    d="M476 348.386L480.392 312 484 365.912 477.996 368z"
                />
                <path
                    id="attendance-illustration_svg__Rectangle"
                    fill="#1B1030"
                    fillRule="nonzero"
                    transform="rotate(-5.72 420.237 534.315)"
                    d="M410.734 534.317l19.005-.003-19.005.003z"
                />
                <path
                    id="attendance-illustration_svg__Path"
                    fill="#F16A33"
                    fillRule="nonzero"
                    opacity={0.62}
                    d="M358 416l113.367-32 4.633 9.075z"
                />
                <path
                    d="M381.942 164.292s-4.314-6.86-8.966-1.746c-4.652 5.114 1.048 19.829 5.326 19.776 4.279-.052 4.812-1.309 4.812-1.309l4.385 12.48s1.136 33.165-14.203 39.483c-15.34 6.319-27.697 21.87-4.226 27.125 23.471 5.254 77.337-1.571 82.93-6.232 0 0-29.117-35.433-26.258-49.798a43.383 43.383 0 008.877-19.794s9.25 1.659 11.806-12.515c1.776-9.478-4.26-11.136-7.102-8.448 0 0 2.22-34.91-31.265-35.31-33.484-.402-26.116 36.288-26.116 36.288z"
                    id="attendance-illustration_svg__Path"
                    fill="#D95B29"
                    fillRule="nonzero"
                />
                <path
                    d="M430 217.116s-2.23-8.51-1.655-11.626L398 200s-.162 22.7 32 17.116z"
                    id="attendance-illustration_svg__Path"
                    fill="#C04F28"
                    fillRule="nonzero"
                />
                <path
                    d="M384 180.738s5.318 27.192 25.489 27.262c17.902 0 20.384-3.52 26.109-23.971 5.725-20.451-51.598-3.291-51.598-3.291z"
                    id="attendance-illustration_svg__Path"
                    fill="#D95B29"
                    fillRule="nonzero"
                />
                <path
                    d="M419.818 168.254L418 164.99c.364-.317 8.89-7.55 20 1.7L436.182 170c-9.255-7.663-16.073-1.995-16.364-1.746zM388.475 164.379L388 160.65c15.237-2.914 19.807 4.885 20 5.206L405.452 168s-3.867-6.128-16.977-3.621z"
                    id="attendance-illustration_svg__Path"
                    fill="#363A43"
                    fillRule="nonzero"
                />
                <path
                    d="M439.22 166s-30.657-20.734-45.078-19.726l-12.836 19.278s-10.95-40.946 30.568-37.325C447.233 131.493 439.221 166 439.221 166z"
                    id="attendance-illustration_svg__Path"
                    fill="#363A43"
                    fillRule="nonzero"
                />
                <path
                    id="attendance-illustration_svg__Path"
                    fill="#892D1D"
                    fillRule="nonzero"
                    d="M405.467 183.759L404 182.667l.652-.667 1.207.88 10.141.24-.033.88z"
                />
                <path
                    d="M404.275 194.228s2.727-4.116 8.072-1.16c5.344 2.956 3.248 5.332 3.248 5.332s-2.412 3.253-7.741.481c-5.329-2.772-3.579-4.653-3.579-4.653z"
                    id="attendance-illustration_svg__Path"
                    fill="#FFC970"
                    fillRule="nonzero"
                />
                <path
                    id="attendance-illustration_svg__Rectangle"
                    fill="#892D1D"
                    fillRule="nonzero"
                    transform="rotate(-73.43 410.139 195.263)"
                    d="M410.144 186.424l-.01 17.678z"
                />
                <path
                    d="M379.204 185.923a4.001 4.001 0 011.567-7.847 4.001 4.001 0 013.156 4.684 4.02 4.02 0 01-4.723 3.163zm1.314-6.707a2.82 2.82 0 00-1.053 5.54 2.819 2.819 0 003.3-2.224 2.839 2.839 0 00-2.247-3.316zM437.222 189.924a4 4 0 111.556-7.847 4 4 0 01-1.556 7.847zm1.314-6.724a2.837 2.837 0 10-1.404 5.499 2.837 2.837 0 001.404-5.499z"
                    id="attendance-illustration_svg__Shape"
                    fill="#363A43"
                    fillRule="nonzero"
                />
                <path
                    d="M381.634 176c-2.018-.346-3.772-1.197-4.914-2.385-.855-1.105-.953-2.41-.27-3.57.345-.838 1.221-1.527 2.389-1.877 1.728-.315 3.566-.184 5.161.37l-.654.861c-1.224-.441-2.643-.561-3.989-.338-.779.243-1.358.711-1.577 1.277-.587.926-.53 1.983.157 2.877.942.955 2.373 1.636 4.012 1.908l-.315.877z"
                    id="attendance-illustration_svg__Path"
                    fill="#892D1D"
                    fillRule="nonzero"
                />
                <path
                    d="M376.653 172l-.653-.718a80.832 80.832 0 015.782-1.282l.218.795c-.435 0-3.048.628-5.347 1.205zM436.476 180l-.476-.937c2.809-.706 5.046-2.228 6.138-4.174 1.834-4.54-2.061-5.952-2.265-6.016l.611-.873s5.141 1.794 2.99 7.159c-1.214 2.251-3.77 4.02-6.998 4.841z"
                    id="attendance-illustration_svg__Path"
                    fill="#892D1D"
                    fillRule="nonzero"
                />
                <path
                    id="attendance-illustration_svg__Rectangle"
                    fill="#892D1D"
                    fillRule="nonzero"
                    transform="rotate(-80.26 442.14 173.938)"
                    d="M442.141 172.126v3.623z"
                />
                <path
                    d="M381.745 224s22.41 63.282 57.044 7.888L460 262.136l-49.238 12.503L356.205 278S342.748 255.623 342 253.62"
                    id="attendance-illustration_svg__Path"
                    fill="#FFF"
                    fillRule="nonzero"
                />
                <path
                    d="M350.34 221.398c.1-1.509.462-2.99 1.07-4.384-5.458-8.27 6.69-10.695 6.69-10.695-.697-11.366 9.738-9.973 9.738-9.973-10.952-11.727 7.724-16.782 7.724-16.782 3.407-13.12 5.35.43 4.138 5.348 0 0 7.135 14.426-3.728 12.964 0 0-.57 10.506-10.453 9.835 0 0 3.247 8.959-5.35 9.13a11.53 11.53 0 013.745 5.159l-6.421-.31-7.153-.292z"
                    id="attendance-illustration_svg__Path"
                    fill="#363A43"
                    fillRule="nonzero"
                />
            </g>
        </g>
    </svg>
);

AttendanceIllustrationSvg.displayName = 'AttendanceIllustrationSvg';
export default AttendanceIllustrationSvg;
